// extracted by mini-css-extract-plugin
module.exports = {"alertMsg":"jFj6NoDMiSLalkYSzj1pu"};